import script from "./memberTabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./memberTabel.vue?vue&type=script&lang=ts&setup=true"

import "./memberTabel.vue?vue&type=style&index=0&id=340c9b4c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-340c9b4c"]])

export default __exports__